/* dtf-gangsheet-film-price.js
   Gang sheet BUILDER (DTF): when the film style (variant option 2) changes, the
   per-size buttons (1 Foot, 2 Feet, 5 Feet, …) must re-price — each film has a
   different price / compare-at / % off per size. The section's inline updater
   (v_showdiscount) is only wired to SIZE (option 1) changes, and it lives in
   sections/main-product.liquid, which is OVER Shopify's 256 KB template limit and
   can no longer be pushed — so the film-change handler never reached the live
   theme. This standalone, self-gated asset adds the missing film-change repricing
   (and aligns the initial render with the checked film, in case the default
   variant's film differs from the checked radio).

   It reads the LIVE checked film radio + the page's `allVariantsForTemplates`
   data — no dependency on the ?variant= URL, which Shopify updates asynchronously
   (and sometimes not at all) on a film change. The UV builder has no film option,
   so the option-2 query matches nothing there and this is a no-op. */
(function () {
  'use strict';

  // Self-gate: DTF builder (template-product-build-a-gang-sheet) and the UV
  // builder (…-build-a-gang-sheet-uv) both match; UV simply has no film row.
  // Gating happens in begin() — this file now loads WITHOUT defer (before
  // <body> exists) so it can price the size buttons as soon as the section's
  // inline variant matrix parses, instead of waiting for DOMContentLoaded
  // (the "x Feet shows, then the price pops in" FOUC, 2026-08-13).

  // The variant matrix is declared as a top-level `const` in the section's inline
  // script, so it's reachable by name from this (later-running) classic script.
  function getData() {
    try { if (typeof allVariantsForTemplates !== 'undefined' && Array.isArray(allVariantsForTemplates)) return allVariantsForTemplates; } catch (e) {}
    try { if (Array.isArray(window.allVariantsForTemplates)) return window.allVariantsForTemplates; } catch (e) {}
    return null;
  }

  function reprice() {
    var data = getData();
    if (!data) return;
    var filmEl = document.querySelector('.product-variant__container[option="2"] input[type="radio"]:checked');

    var list;
    if (filmEl) {
      var film = (filmEl.value || '').toLowerCase().trim();
      // Visible variants for the selected film, in data order — mirrors the inline
      // v_showdiscount's { option2, variant_hidden:false } filter + index mapping.
      list = data.filter(function (v) { return v.option2 === film && !v.variant_hidden; });
    } else if ((document.body.className || '').indexOf('build-a-gang-sheet-uv') >= 0) {
      // UV builder: single-option product (no film picker). Fill the size
      // buttons here too, so prices + "% off" land together at DOMContentLoaded
      // instead of waiting ~1s for the section's late inline pass (the
      // "price pops in, then % off" FOUC Justin reported 2026-08-13).
      list = data.filter(function (v) { return !v.variant_hidden; });
    } else {
      return;
    }
    var radios = document.querySelectorAll('.product-variant__container[option="1"] input[type="radio"]');

    radios.forEach(function (r, i) {
      var item = r.closest('.product-variant__item');
      var d = list[i];
      if (!item || !d) return;
      var price   = item.querySelector('.nt-vp-price');
      var compare = item.querySelector('.nt-vp-compare');
      var saving  = item.querySelector('.saving-info');
      // Write ONLY on change: textContent assignment replaces the text node
      // even for identical strings, which fires childList mutations — with
      // the parse-time MutationObserver below, unconditional writes create a
      // write->mutation->reprice loop that pegs the CPU (staging incident
      // 2026-08-13).
      var pv = d.price || '';
      var cv = d.compare_at || '';
      var sv = (d.discount_p != null && d.discount_p !== '' ? d.discount_p : '');
      if (price   && price.textContent   !== pv) price.textContent   = pv;
      if (compare && compare.textContent !== cv) compare.textContent = cv;
      if (saving  && saving.textContent  !== sv) saving.textContent  = sv;
    });
  }

  // The film's own change handlers can re-render asynchronously, so re-apply a
  // couple of times. The first pass runs while :checked is already updated.
  function repriceSoon() { reprice(); setTimeout(reprice, 220); setTimeout(reprice, 600); }

  /* Parse-time fill: a document-wide MutationObserver runs reprice() as the
     page streams in. The inline variant matrix parses ~186KB AFTER the size
     markup, so prices land the moment that const evaluates — typically still
     before this region's first paint, and far earlier than DOMContentLoaded.
     reprice() maps radios[i] -> list[i], so partially-parsed rows price
     correctly as a prefix. Script order matters: dtf-film-style-lock.js
     registers its observer first (earlier script tag), so the film default
     is already flipped to VIVID AF before this observer prices — no
     silver-priced flicker. theme.css keeps the price/% spans invisible until
     the first saving lands, then everything reveals in one frame. */
  function tick() { reprice(); }

  /* Coalesce observer bursts into one microtask-deferred tick — microtasks
     still run before paint (parse-time guarantee holds), but hundreds of
     mutation batches during page parse collapse into a handful of ticks. */
  var queued = false;
  function onMutation() {
    if (queued) return;
    queued = true;
    queueMicrotask(function () { queued = false; tick(); });
  }

  function begin() {
    if ((document.body.className || '').indexOf('template-product-build-a-gang-sheet') < 0) return;

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.product-variant__container[option="2"] input[type="radio"]')) repriceSoon();
    }, true);

    tick();
    new MutationObserver(onMutation).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', tick);
    [300, 1000, 2500].forEach(function (ms) { setTimeout(tick, ms); });
  }

  if (document.body) begin();
  else new MutationObserver(function (m, o) {
    if (document.body) { o.disconnect(); begin(); }
  }).observe(document.documentElement, { childList: true });
})();
